import "./DiferencaVariavel.css"

import React, { useState, useEffect } from 'react';
import { formatMonetary } from '../utils/tools/mask';
import { division, getDifferenceInDays, multiplication, sum } from '../utils/tools/functions';

const HistoricoSalarial = ({ form, setForm, prefix }) => {
    const [dataInicial, setDataInicial] = useState(form[`${prefix}.data_inicial`] || '');
    const [dataFinal, setDataFinal] = useState(form[`${prefix}.data_final`] || '');
    const [pagamentos, setPagamentos] = useState(() => {
        const pagamentosIniciais = form?.[`${prefix}.pagamentos`];
        return pagamentosIniciais && pagamentosIniciais.length > 0 ? pagamentosIniciais : [{ de: '', ate: '', valor: "" }];
    });

    const [totalPago, setTotalPago] = useState(form[`${prefix}.total_pago`] || "");

    function handleDataPagamento(index, data = "") {
        const updatedPagamentos = [...pagamentos];
        updatedPagamentos[index].ate = data;
        setPagamentos(updatedPagamentos);
    }

    const validateDate = (index, list, setList) => (e) => {
        let { name, value } = e.target;
        const updatedList = [...list];

        if (isDateBefore(updatedList[index].de, value)) {
            alert('A data "ate" ser menor que a data ' + value);
            value = ""
        }

        if (!dataFinal) {
            alert('Preencha o valor da data final!');
            value = ""
        }

        if (!!dataFinal && isDateBefore(value, nextDay(dataFinal))) {
            alert('A data "ate" ser menor que a data ' + dataFinal);
            value = ""
        }

        updatedList[index][name] = value;
        if (index < list.length - 1) {
            updatedList[index + 1].de = nextDay(value);
        }
        setList(updatedList)
    };

    const nextDay = (date) => {
        const d = new Date(date);
        d.setDate(d.getDate() + 1);
        return d.toISOString().split('T')[0];
    };

    const addPeriod = (list, setList) => () => {
        const lastPeriod = list[list.length - 1];
        if (!lastPeriod.ate || isDateBefore(lastPeriod.ate, dataFinal)) {
            alert('A data "ate" do último período deve estar preenchida e ser menor que a data final');
            return;
        }
        const newPeriod = { de: nextDay(lastPeriod.ate), ate: '', valor: 0 };
        setList([...list, newPeriod]);
    };

    const removePeriod = (index, list, setList) => () => {
        if (list.length > 1) {
            setList(list.filter((_, i) => i !== index));
        }
    };

    const handleChangDataInicial = (date) => {
        if (!isDateBefore(date, dataFinal)) {
            setDataInicial(date);
            setPagamentos((prev) => {
                const newPagamentos = [...prev];
                newPagamentos[0].de = date;
                return newPagamentos;
            });
        } else {
            setDataInicial("")
            alert('A data inicial deve ser anterior à data final');
        }
    }

    const handleChangDataFinal = (date) => {
        if (!isDateBefore(dataInicial, date)) {
            setDataFinal(date);
        } else {
            setDataFinal("")
            alert('A data final deve ser posterior à data inicial');
        }
    }

    const isDateBefore = (date1, date2) => {
        const [year1, month1, day1] = date1.split('-');
        const [year2, month2, day2] = date2.split('-');
        const d1 = new Date(year1, month1 - 1, day1);
        const d2 = new Date(year2, month2 - 1, day2);
        return d2 <= d1;
    };

    const handleChangeValue = (index, list, setList) => (e) => {
        let { name, value } = e.target;
        const updatedList = [...list];
        updatedList[index][name] = value;
        setList(updatedList)
    }

    const handleBlurValue = (index, list, setList) => (e) => {
        let { name, value } = e.target;
        const updatedList = [...list];

        value = formatMonetary(value)
        updatedList[index][name] = value;
        setList(updatedList)
    };

    const calcularTotal = () => {
        const pagamentosPorPeriodos = []

        pagamentos.map(pagamento => {
            try {
                const dias = getDifferenceInDays(pagamento.de, pagamento.ate) + 1
                const diaria = division([pagamento.valor || "R$ 0,00", 30])
                const total = multiplication([dias, diaria])

                pagamentosPorPeriodos.push(total)
            } catch (e) {
                pagamentosPorPeriodos.push("R$ 0")
            }
        })

        try {
            const total_pago = sum(pagamentosPorPeriodos, "sum")
            setTotalPago(total_pago);

            setForm({
                ...form,
                [`${prefix}.data_inicial`]: dataInicial,
                [`${prefix}.data_final`]: dataFinal,
                [`${prefix}.pagamentos`]: pagamentos,
                [`${prefix}.total_pago`]: total_pago,
            });

        } catch (e) {
            console.log(e.message)
        }
    }

    useEffect(() => {
        calcularTotal();
    }, [pagamentos, dataInicial, dataFinal]);

    return (
        <div className='DiferencaVariavel'>
            <h3>{prefix}</h3>
            <div className="data_inicial">
                <label htmlFor="h_dateInicial">Data Inicial:</label>
                <input
                    type="date"
                    id='h_dateInicial'
                    value={dataInicial}
                    onChange={e => setDataInicial(e.target.value)}
                    onBlur={e => handleChangDataInicial(e.target.value)}
                />
            </div>
            <div className="data_final">
                <label htmlFor="h_dateFinal">Data Final:</label>
                <input
                    type="date"
                    id='h_dateFinal'
                    value={dataFinal}
                    onChange={e => setDataFinal(e.target.value)}
                    onBlur={e => handleChangDataFinal(e.target.value)}
                />
            </div>

            <h3>Valores Pagos</h3>
            <div className="section-info">Preencha os períodos em que os pagamentos foram efetuados.</div>
            {pagamentos.map((pagamento, index) => (
                <div key={`h_pagamento_${index}`}>
                    <input
                        type="date"
                        name="de"
                        value={pagamento.de}
                        readOnly={index === 0}
                        disabled={true}
                    />
                    <input
                        type="date"
                        name="ate"
                        value={pagamento.ate}
                        onChange={e => handleDataPagamento(index, e.target.value)}
                        onBlur={validateDate(index, pagamentos, setPagamentos)}
                    />
                    <input
                        type="text"
                        name="valor"
                        value={pagamento.valor}
                        onChange={handleChangeValue(index, pagamentos, setPagamentos)}
                        onBlur={handleBlurValue(index, pagamentos, setPagamentos)}
                    />
                    <button className="bt-remove" type="button" onClick={removePeriod(index, pagamentos, setPagamentos)}>Remover Período</button>
                </div>
            ))}
            <button className="bt-add" type="button" onClick={addPeriod(pagamentos, setPagamentos)}>Adicionar Período</button>

            <h3>Total</h3>
            <div className="section-info">Veja abaixo o resumo dos valores pagos e devidos, e a diferença entre eles.</div>
            <div>
                <label htmlFor="h_total_pago">Total Pago:</label>
                <input id="h_total_pago" type="text" value={totalPago} readOnly />
            </div>
        </div>
    );
};

export default HistoricoSalarial;
